import MDBox from "components/MDBox";
import MDModal from "components/MDModal";
import React from "react";

export default function ActifModal({ open, setOpen, title, children }) {
  return (
    <MDModal title={title} open={open} setOpen={setOpen}>
      {children}
    </MDModal>
  );
}
